import React from "react";
import { createRoot } from "react-dom/client";
import "../brand-assets/brand-tokens.css";
import "./styles.css";
import App from "./App.jsx";
import ProductPage from "./ProductPage.jsx";
import MarketEntryPage from "./MarketEntryPage.jsx";
import SalesIntelligencePage from "./SalesIntelligencePage.jsx";
import WhoItsForPage from "./WhoItsForPage.jsx";
import AboutPage from "./AboutPage.jsx";
import GrowthPage from "./GrowthPage.jsx";
import WalkthroughPage from "./WalkthroughPage.jsx";
import FAQPage from "./FAQPage.jsx";
import InsightsPage from "./InsightsPage.jsx";
import InsightArticlePage, { InsightNotFoundPage } from "./InsightArticlePage.jsx";
import LegalPage from "./LegalPage.jsx";
import PrivacyRequestPage from "./PrivacyRequestPage.jsx";
import AnalyticsConsent from "./AnalyticsConsent.jsx";
import { getPublishedInsight } from "../content/insights/articles.js";
import { internalInsightSample } from "../content/insights/internal-sample.js";
import { insightArticleDraft01 } from "../content/insights/drafts/01-research-market-before-prospect-list.js";

const GrowthBlogPage = React.lazy(() => import("./GrowthBlogPage.jsx"));

const path = window.location.pathname.replace(/\/$/, "");
const insightSlug = path.startsWith("/insights/") ? path.slice("/insights/".length) : null;
const growthBlogSlug = path.startsWith("/blog/") ? path.slice("/blog/".length) : null;
const publishedInsight = insightSlug ? getPublishedInsight(insightSlug) : null;
const localHost = ["127.0.0.1", "localhost"].includes(window.location.hostname);
const growthBlogRoute = path === "/blog" || growthBlogSlug;
const internalTemplate = localHost && path === "/insights" && new URLSearchParams(window.location.search).get("__template") === "1";
const internalDraft = localHost && insightSlug === insightArticleDraft01.slug && new URLSearchParams(window.location.search).get("__draft") === "1";
const legalType = ["/privacy", "/terms", "/business-contact-data", "/ms/privacy", "/ms/business-contact-data"].includes(path) ? path.slice(1) : null;
const canonical = document.querySelector('link[rel="canonical"]') || document.head.appendChild(Object.assign(document.createElement("link"), { rel: "canonical" }));
canonical.href = `https://appingtechnology.com${path || "/"}`;
const Page = path === "/product" ? ProductPage : path === "/market-entry" ? MarketEntryPage : path === "/sales-intelligence" ? SalesIntelligencePage : path === "/who-its-for" ? WhoItsForPage : path === "/growth" ? GrowthPage : growthBlogRoute ? GrowthBlogPage : path === "/about" ? AboutPage : path === "/book-a-walkthrough" ? WalkthroughPage : path === "/faq" ? FAQPage : path === "/privacy-request" ? PrivacyRequestPage : legalType ? LegalPage : internalTemplate || internalDraft ? InsightArticlePage : path === "/insights" ? InsightsPage : insightSlug ? (publishedInsight ? InsightArticlePage : InsightNotFoundPage) : App;

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <React.Suspense fallback={null}>
      <Page type={legalType} article={internalTemplate ? internalInsightSample : internalDraft ? insightArticleDraft01 : publishedInsight} growthBlogSlug={growthBlogSlug} />
    </React.Suspense>
    <AnalyticsConsent />
  </React.StrictMode>,
);
